import * as React from "react";
import './styles.scss';

const GiftOffer = () => {
    return (
        <div className="p-20">
            <div className="gift-title">10% Discount Code</div>
            <img src="/static/images/dwa/gift.png" alt="" className="gift-img" />
        </div>
    );
};

export { GiftOffer };